module.exports = __webpack_public_path__ + "img/lygz.f71d6eab.jpg";